import React, { FC } from 'react'
import SidebarSkeleton from '../SidebarSkeleton'
import ListSkeleton from '../ListSkeleton'
import './index.scss'

/** 经典模式的skeleton */
const ClassicSkeleton: FC = () => {
  return (
    <div className='classic-skeleton'>
      <SidebarSkeleton />
      <ListSkeleton />
    </div>
  )
}

export default ClassicSkeleton
